// extracted by mini-css-extract-plugin
export default {"header":"styles_header__641io","title":"styles_title__NDiIi","row":"styles_row__OhQ-D"};